import React from 'react';

import SideNavigation from '../SideNavigation';

import './Layout.scss';

const Layout = ({ children }) => {
  return (
    <>
      <div className="app-wrapper">
        <SideNavigation />
        <div className="mainContent">{children}</div>
      </div>
    </>
  );
};

export { Layout };
export default Layout;
